import { render, staticRenderFns } from "./ChooseObjects.vue?vue&type=template&id=6cde866a&scoped=true"
import script from "./ChooseObjects.vue?vue&type=script&lang=js"
export * from "./ChooseObjects.vue?vue&type=script&lang=js"
import style0 from "./ChooseObjects.vue?vue&type=style&index=0&id=6cde866a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cde866a",
  null
  
)

export default component.exports